import React from 'react'
import '../App.css'
import { MainCast } from './Castellano/MainCast'
import { MainCat } from './Catalan/MainCat'

export function Main({ language, taller }) {
    return (
        <>
            {taller !== null ? (
                language === 'castellano' || language === 'castellà' ? (
                    <MainCast taller={taller} />
                ) : (
                    <MainCat taller={taller} />
                )
            ) : (
                ''
            )}
        </>
    )
}
